import { Reducer } from "redux";
import { TGetWhiteLabelConfigAction } from "../../../@types/Action/TWhiteLabelConfigAction";
import { TGetWhiteLabelConfigsState } from "../../../@types/State/TWhiteLabelConfigState";
import { whiteLabelConfig } from "../../actions/actionTypes";

export const getWhiteLabelConfigsInitialState: TGetWhiteLabelConfigsState = {
  data: null,
  loading: false,
  didInvalidate: true,
  hasErrors: false,
  error: null,
};

export const getWhiteLabelConfigsReducer: Reducer<
  TGetWhiteLabelConfigsState,
  TGetWhiteLabelConfigAction
> = (state = getWhiteLabelConfigsInitialState, action) => {
  switch (action.type) {
    case whiteLabelConfig.GET_WHITE_LABEL_CONFIGS_INVALIDATE:
      return {
        ...state,
        didInvalidate: true,
      };
    case whiteLabelConfig.GET_WHITE_LABEL_CONFIGS_SUCCESS:
      return {
        didInvalidate: false,
        loading: false,
        error: null,
        hasErrors: false,
        data: action.payload,
      };
    case whiteLabelConfig.GET_WHITE_LABEL_CONFIGS_FETCHING:
      return {
        ...state,
        didInvalidate: false,
        loading: true,
      };
    case whiteLabelConfig.GET_WHITE_LABEL_CONFIGS_ERROR:
      return {
        ...state,
        didInvalidate: false,
        loading: false,
        hasErrors: true,
        error: action.error,
      };
    case whiteLabelConfig.GET_WHITE_LABEL_CONFIGS_CLEAR:
      return getWhiteLabelConfigsInitialState;
    default:
      return state;
  }
};
